import { Box, Typography, Button, Grid } from "@mui/material";
import { FaTwitter, FaInstagram, FaLinkedin, FaYoutube, FaFacebook } from 'react-icons/fa';
import { Link } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Footer from "../components/mainpage/Footer";
import Headerpage from "../components/mainpage/Headerpages/learnersHederpage";

const PageNotFound = () => {

  return (
     <>
      <div className="students-flex">
        <Headerpage />
        <div className="homepagecolores">
        <div style={{ width : "100%", overflowX: "hidden", overflowY: "auto", height : "91vh"}}>
        {/* 404 Section */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#006affff",
            textAlign: "center",
            px: 3,
            py: 16,
          }}
        >
          <Grid
            container
            spacing={4}
            direction="column"
            alignItems="center"
            justifyContent="center"
            maxWidth="700px"
          >
            {/* Big 404 */}
            <Typography
              variant="h4"
              sx={{
                fontWeight: "600",
                fontSize: { xs: "4rem", md: "8rem" },
                lineHeight : 1,
                letterSpacing: "-5px",
              }}
            >
              404
            </Typography>

            {/* Icon */}
            <ErrorOutlineIcon
              sx={{
                fontSize: 90,
                mb: 2,
                color: "#FFD700",
                animation: "pulse 2s infinite",
              }}
            />

            {/* Message */}
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                mb: 1,
              }}
            >
              Oops! Page Not Found
            </Typography>
            <Typography
              variant="body1"
              sx={{
                maxWidth : "500px",
                mb: 3,
                color: "#0073ffff",
              }}
            >
              The page you’re looking for might have been moved, deleted, or is temporarily unavailable.
            </Typography>

            {/* Back Button */}
            <Button
              variant="contained"
              sx={{
                bgcolor: "#FFD700",
                color: "#043885",
                fontWeight: "bold",
                px: 5,
                py: 1.5,
                borderRadius: "40px",
                fontSize: "1rem",
                textTransform: "none",
                boxShadow: "0px 6px 15px rgba(0,0,0,0.2)",
                "&:hover": { bgcolor: "#f5c518", transform: "scale(1.05)" },
                transition: "all 0.3s ease",
              }}
              onClick={() => window.open("https://site.huebits.in/")}
            >
              Back to Home
            </Button>
          </Grid>
          </Box>
          </div>
           <div className="homepage-footers-images">
               <Footer />
            <footer className="homepage-footers">
            <hr className='homepage-footer-hr'/>
            <div className="learners-footers-seokeywords">
            </div>
              <div className="footer-social">
              <div className="homepage-footer-copyright">
                <p>© Huebits[2025].All Rights Reserved.</p>
              </div>
              <div className='footer-social-icons'>
                <Link to="https://www.linkedin.com/company/huebits/mycompany" target="_blank" rel="noopener noreferrer"><FaLinkedin  className="social-icon"/></Link>
                <Link to="https://x.com/HuebitsTech" target="_blank" rel="noopener noreferrer"><FaTwitter className="social-icon" /></Link>
                <Link to="https://www.instagram.com/huebits_tech/" target="_blank" rel="noopener noreferrer"><FaInstagram className="social-icon" /></Link>
                <Link to="https://www.youtube.com/@HuebitsTech" target="_blank" rel="noopener noreferrer"><FaYoutube className="social-icon" /></Link>
                <Link to="https://www.facebook.com/profile.php?id=61571753805069" target="_blank" rel="noopener noreferrer"><FaFacebook className="social-icon" /></Link>
            </div>
            </div>
            </footer>
            </div>
            </div>
        </div>
    </>
  );
};

export default PageNotFound;
